import React, { useMemo } from 'react';
import { Box, Preloader } from '@common-fe/common-fe';

import BeneficiariesList from './BeneficiariesList';
import SpecialStatesWarning from './SpecialStatesWarning';
import useGetBeneficiariesQuery, { BeneficiaryType } from './useGetBeneficiaries.query';
import { useHasAccessToViewBeneficiaries } from './useHasBeneficiaryAccess';
import useHasWarningAddressState from './useHasWarningAddressState';

const Beneficiaries = () => {
  const hasWarningState = useHasWarningAddressState();
  const hasAccessToViewBeneficiaries = useHasAccessToViewBeneficiaries();
  const { isLoading, formattedData } = useGetBeneficiariesQuery(hasAccessToViewBeneficiaries);
  const [primaryBeneficiaries, contingentBeneficiaries] = useMemo(() => [
    formattedData?.filter((item) => item?.beneficiaryType === BeneficiaryType.PRIMARY),
    formattedData?.filter((item) => item?.beneficiaryType === BeneficiaryType.CONTINGENT),
  ], [formattedData]);
  const hasContingentBeneficiary = useMemo(() => Boolean(contingentBeneficiaries?.length),
    [contingentBeneficiaries]);

  if (!hasAccessToViewBeneficiaries) return null;

  return (
    <Box data-testId="Beneficiaries" margin={{ top: 'spacing16', bottom: 'spacing24' }}>
      {primaryBeneficiaries?.length && hasWarningState ? (
        <Box margin={{ bottom: 'spacing16' }}>
          <SpecialStatesWarning />
        </Box>
      ) : null}
      {isLoading ? <Preloader /> : (
        <Box>
          <BeneficiariesList
            beneficiaries={primaryBeneficiaries}
            beneficiaryType={BeneficiaryType.PRIMARY}
            isRemovingAllPrimaryBeneficiariesButtonHidden={hasContingentBeneficiary}
          />

          <Box margin={{ top: 'spacing16' }}>
            <BeneficiariesList
              beneficiaries={contingentBeneficiaries}
              beneficiaryType={BeneficiaryType.CONTINGENT}
              isAddButtonDisabled={!primaryBeneficiaries?.length}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Beneficiaries;
